import React, {Component} from "react";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import {Link} from "react-router-dom";
import HomeIcon from '@material-ui/icons/Home';
import {Button, CircularProgress, Snackbar} from "@material-ui/core";
import MySnackbarContentWrapper from "../components/Snackbar";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import moment from "moment";
import {Checkbox, DatePicker, Select} from "antd";
import Typography from "@material-ui/core/Typography";

const {Option} = Select;

class CorporateClientEditFormScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clientId: props.location.pathname.substring(props.location.pathname.length, props.location.pathname.lastIndexOf('/') + 1),
            corporateId:props.location.pathname
                .replace("/corporate/", "")
                .substring(
                    0,
                    props.location.pathname.replace("/corporate/", "").indexOf("/")
                ),
            fromBack: false,
            selectedSsnValue: '',
            ssn: [],
            selectedData: [],
            visible: true,
            valid: false,
            changed: false,
            isChangedFirst: false,
            contactVisible: false,
            contacts: [],
            setValue: false,
            openDeleteContactDialogue: false,
            id:"",
        };
        if (props.location.pathname.replace('/corporate/:coporateId/clientupdate/', '').length > 0) {
            this.props.getClientInfo(this.state.clientId)
        }
    }

    componentWillMount() {
        this.props.fetchClientList();
    }

    componentWillUnmount() {
        this.props.handleSnackBarClose();
        this.props.setClientData({
            ssn: "",
            firstName: "",
            lastName: "",
            gender: "",
            dob: "",
            maritalStatus: ""
        })
    }

    render() {
        const corporateClientData = this.props.state.corporateClientState && this.props.state.corporateClientState.corporateClientData;

        const getDate = (dateToConvert) => {
            let dateConverted = new Date(parseInt(dateToConvert)).toLocaleDateString('fr-CA');
            return moment(dateConverted,"YYYY-MM-DD");
        };
        const handleChangeDateContact = (range) => {
            if(range) {
                const valueOfInput1 = range.format();
                changeContactFieldDobValue(this.state.id, new Date(valueOfInput1).getTime());
            }
        }

        const handleClickOpenDeleteContactDialogue = contactId => {
            this.setState({
                openDeleteContactDialogue: true,
                contactId: contactId
            });
        };
        const handleCloseDeleteContactDialogue = () => {
            this.setState({
                openDeleteContactDialogue: false,
                contactId: ""
            });
        };

        const handleOkDeleteContactDialogue = () => {
            closeContactFieldSection(this.state.contactId);
            this.setState({
                openDeleteContactDialogue: false,
                contactId: ""
            });
        };

        const showInputForField = () => {
            let a = createAddContactObject();
            this.setState({
                openDropdownForContact: true,
                contacts: [...this.state.contacts, a]
            });
        };

        const createAddContactObject = () => {
            return {
                contactId: String(Math.random()),
                name: '',
                emailPhone: '',
                contactType: -1,
                phone: '',
                address: '',
                dob: '',
            };
        };

        const changeContactFieldNameValue = (key, value) => {
            let newContact = this.state.contacts.filter(single => single.contactId === key)[0];
            newContact.name = value;
            let otherContacts = this.state.contacts.filter(single => single.contactId !== key);
            otherContacts.splice(this.state.contacts.findIndex(single => single.contactId === key), 0, newContact);
            this.setState({ contacts: otherContacts });
            this.props.handleChangeCorporateClientEdit("contacts", this.state.contacts)
        };

        const changeContactFieldEmailValue = (key, value) => {
            let newContact = this.state.contacts.filter(single => single.contactId === key)[0];
            newContact.emailPhone = value;
            let otherContacts = this.state.contacts.filter(single => single.contactId !== key);
            otherContacts.splice(this.state.contacts.findIndex(single => single.contactId === key), 0, newContact);
            this.setState({ contacts: otherContacts });
            this.props.handleChangeCorporateClientEdit("contacts", this.state.contacts)
        };

        const changeContactFieldTypeValue = (key, value) => {
            let newContact = this.state.contacts.filter(single => single.contactId === key)[0];
            newContact.contactType = value;
            let otherContacts = this.state.contacts.filter(single => single.contactId !== key);
            otherContacts.splice(this.state.contacts.findIndex(single => single.contactId === key), 0, newContact);
            this.setState({ contacts: otherContacts });
            this.props.handleChangeCorporateClientEdit("contacts", this.state.contacts)
        };
        const changeContactFieldPhoneValue = (key, value) => {
            let newContact = this.state.contacts.filter(single => single.contactId === key)[0];
            newContact.phone = value;
            let otherContacts = this.state.contacts.filter(single => single.contactId !== key);
            otherContacts.splice(this.state.contacts.findIndex(single => single.contactId === key), 0, newContact);
            this.setState({ contacts: otherContacts });
            this.props.handleChangeCorporateClientEdit("contacts", this.state.contacts)
        };
        // const changeContactFieldAddressValue = (key, value) => {
        //     let newContact = this.state.contacts.filter(single => single.contactId === key)[0];
        //     newContact.address = value;
        //     let otherContacts = this.state.contacts.filter(single => single.contactId !== key);
        //     otherContacts.splice(this.state.contacts.findIndex(single => single.contactId === key), 0, newContact);
        //     this.setState({ contacts: otherContacts });
        //     this.props.handleChangeCorporateClientEdit("contacts", this.state.contacts)
        // };
        const changeContactFieldDobValue = (key, value) => {
            let newContact = this.state.contacts.filter(single => single.contactId === key)[0];
            newContact.dob = value;
            let otherContacts = this.state.contacts.filter(single => single.contactId !== key);
            otherContacts.splice(this.state.contacts.findIndex(single => single.contactId === key), 0, newContact);
            this.setState({ contacts: otherContacts });
            this.props.handleChangeCorporateClientEdit("contacts", this.state.contacts)
        };

        const closeContactFieldSection = key => {
            var removedActionData = this.state.contacts.filter(single => single.contactId !== key);
            this.setState({
                contacts: removedActionData
            }, () => {
                this.props.handleChangeCorporateClientEdit("contacts", this.state.contacts)
            })
        };

        const openFieldForContact = () => {
            let div = [];
            if (this.state.contacts.length > 0) {
                div.push(<>
                    <h5 style={{
                        width: '100%',
                        color: '#8BC83F',
                        paddingTop: '1rem',
                        paddingBottom: '0.8rem',
                        fontWeight: '550'
                    }}>List of contacts</h5>
                    <div className='row'>
                        <div className="col-2">
                            <label htmlFor="contact" className="columnHeadingContactName">Name
                                <span style={{color:"red"}}> *</span></label>
                        </div>
                        <div className="col-2" style={{paddingLeft: 0}}>
                            <label htmlFor="emailPhone" className="columnHeadingContactEmail">Email
                                <span style={{color:"red"}}> *</span></label>
                        </div>
                        <div className="col-2">
                            <label htmlFor="emailPhone" className="columnHeadingContactType">Contact Type
                                <span style={{color:"red"}}> *</span></label>
                        </div>
                        <div className="col-2">
                            <label htmlFor="phone" className="columnHeadingContactPhone">Phone Number</label>
                        </div>
                        {/*<div className="col-2">*/}
                        {/*    <label htmlFor="address" className="columnHeadingContactAddress">Address</label>*/}
                        {/*</div>*/}
                        <div className="col-2">
                            <label htmlFor="dob" className="columnHeadingContactDob">Date-of-birth</label>
                        </div>
                    </div>
                </>)
            }

            if (this.state.contacts[0] !== undefined && this.state.contacts[0].contactId) {
                this.state.contacts.map(single => {
                    return div.push(
                        <div className='row'>
                            <div className="col-2">
                                <input
                                    id={single.id}
                                    className="inputFieldContactName"
                                    value={single.name}
                                    onChange={(e) => {
                                        e.preventDefault();
                                        this.setState({isBlocking: true});
                                        changeContactFieldNameValue(single.contactId, e.target.value);
                                    }}
                                />
                            </div>
                            <div className="col-2" style={{paddingRight: 0, paddingLeft: 0}}>
                                <input
                                    id={single.id}
                                    className="inputFieldContactEmail"
                                    value={single.emailPhone}
                                    onChange={(e) => {
                                        e.preventDefault();
                                        this.setState({isBlocking: true});
                                        changeContactFieldEmailValue(single.contactId, e.target.value);
                                    }}
                                />
                            </div>
                            <div className="col-2" style={{paddingRight: 0, maxWidth: '20%'}}>
                                <div style={style.select}>
                                    <select
                                        id={single.id}
                                        value={single.contactType}
                                        className="inputFieldContactType"
                                        onChange={e => {
                                            e.preventDefault();
                                            this.setState({isBlocking: true});
                                            changeContactFieldTypeValue(single.contactId, e.target.value)
                                        }}
                                    >
                                        <option value hidden/>
                                        <option value="EVERFUND_USER_CONTACT">Everfund User</option>
                                        <option value="CORPORATE_CONTACT">Corporate</option>
                                        <option value="CLIENT_CONTACT">Client</option>
                                        <option value="CLIENT_RELATIVE_CONTACT">Client Relative</option>
                                        <option value="OTHER_CONTACT_TYPE">Other contact type</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-2" style={{paddingRight: 0, maxWidth: '35%'}}>
                                <input
                                    id={single.id}
                                    className="inputFieldContactPhone"
                                    value={single.phone}
                                    onChange={(e) => {
                                        e.preventDefault();
                                        this.setState({isBlocking: true});
                                        changeContactFieldPhoneValue(single.contactId, e.target.value);
                                    }}
                                />
                            </div>
                            {/*<div className="col-2">*/}
                            {/*    <input*/}
                            {/*        id={single.id}*/}
                            {/*        className="inputFieldContactAddress"*/}
                            {/*        value={single.address}*/}
                            {/*        onChange={(e) => {*/}
                            {/*            e.preventDefault();*/}
                            {/*            this.setState({isBlocking: true});*/}
                            {/*            changeContactFieldAddressValue(single.contactId, e.target.value);*/}
                            {/*        }}*/}
                            {/*    />*/}
                            {/*</div>*/}
                            <div className="col-1">
                                <div className="select-add-date-contact" onClick={()=>{
                                    this.setState({isBlocking: true, id: single.contactId})
                                }}>
                                    <DatePicker
                                        value={single.dob && getDate(single.dob)}
                                        format="MM-DD-YYYY"
                                        onChange={handleChangeDateContact}
                                    />
                                </div>
                            </div>
                            <div className="col-1" style={{paddingLeft: '89px', position: 'inherit'}}>
                                <RemoveCircleOutlineIcon
                                    style={{
                                        color: "grey",
                                        width: "24px",
                                        height: "24px",
                                        marginTop: "1.3rem",
                                        cursor: 'pointer'
                                    }}
                                    onClick={e => {
                                        console.log("passing id", single.id);
                                        e.preventDefault();
                                        this.setState({isBlocking: true});
                                        handleClickOpenDeleteContactDialogue(single.contactId);
                                    }}
                                />
                            </div>
                        </div>
                    );
                });
            }
            return div;
        };

        const editClientAPICall = () => {
            this.props.editClient(corporateClientData,this.state.corporateId,this.props)
        };

        const handleChangeDate = (range) => {
            this.setState({
                isBlocking: true,
            })
            if(range) {
                const valueOfInput1 = range.format();
                this.props.handleChangeCorporateClientEdit("dob", new Date(valueOfInput1).getTime());
            }
        }
        return (
            <React.Fragment>
                {console.log("client",corporateClientData)}
                {this.state.setValue === false && corporateClientData && corporateClientData.contacts && corporateClientData.contacts.length > 0 ?
                    this.setState({
                        contacts: corporateClientData.contacts,
                        setValue: true
                    }) : null}

                {this.state.changed === false && this.props.state.corporateClientState.clientData ? this.setState({
                    selectedData: this.props.state.corporateClientState.clientData,
                    selectedSsnValue: this.props.state.corporateClientState.clientData.ssn,
                    changed: true,
                    fromBack: true
                }) : null}

                {this.props.state.corporateClientState.loading ? (
                    <div
                        className={
                            this.props.state.corporateClientState.loading ? "loader" : "loader hidden"
                        }
                        id="loader"
                    >
                        <CircularProgress style={{color: "#8BC83F"}}/>
                    </div>
                ) : null}

                <Breadcrumbs aria-label="breadcrumb" style={style.breadcrumb}>
                    <Link color="inherit" to="/dashboard" style={style.link}>
                        <HomeIcon style={{color: '#8BC83F', paddingBottom: '2px'}}/>Home
                    </Link>
                    <Link color="inherit" to="/corporate" style={style.link}>
                        Corporate
                    </Link>
                    <Link color="inherit" onClick={(e) => {
                        e.preventDefault();
                        this.props.history.push("/corporate/client/" + this.state.corporateId)
                    }}
                          style={style.link}>
                        Client
                    </Link>
                    <Typography color="inherit" className="link">
                        Update Client
                    </Typography>
                </Breadcrumbs>

                <div style={style.container}>
                    <div className="row" style={style.row}>
                        <div className="col-4" style={style.column1}>

                            <label htmlFor="ssn" style={style.columnHeading}>Client Id <span style={{color:"red"}}> *</span></label>
                                    <input value={corporateClientData && corporateClientData.ssn}
                                           data-target="#ssn1" style={{
                                        border: '0',
                                        backgroundColor: '#F8F8F8',
                                        color: 'rgb(130, 132, 129)',
                                        fontSize: '14x',
                                        height: '40px',
                                        width: '90%',
                                        paddingTop: '0px',
                                        marginTop: '16px',
                                        paddingLeft: '15px',
                                    }}/>
                        </div>

                        <div className="col-4">
                            <label htmlFor="firstName" style={style.columnHeading}>First Name
                                <span style={{color:"red"}}> *</span></label>
                            <input
                                type='name'
                                id="firstName"
                                style={style.inputField}
                                value={corporateClientData && corporateClientData.firstName}
                                onChange={(e) => {
                                    e.preventDefault();
                                    this.setState({isBlocking: true});
                                    this.props.handleChangeCorporateClientEdit(e.target.id, e.target.value);
                                }}
                            />
                        </div>
                        <div className="col-4">
                            <label htmlFor="lastName" style={style.columnHeading}>Last Name
                                <span style={{color:"red"}}> *</span></label>
                            <input
                                id="lastName"
                                style={style.inputField}
                                value={corporateClientData && corporateClientData.lastName}
                                onChange={(e) => {
                                    e.preventDefault();
                                    this.setState({isBlocking: true});
                                    this.props.handleChangeCorporateClientEdit(e.target.id, e.target.value);
                                }}
                            />
                        </div>
                    </div>

                    <div className="row" style={{marginTop: '2rem'}}>
                        <div className="col-4" style={{position: 'inherit'}}>
                            <label htmlFor="dob" style={style.columnHeading}>Date-Of-Birth
                                <span style={{color:"red"}}> *</span></label>
                            <div className="select-input-date">
                                <DatePicker
                                    value={corporateClientData && getDate(corporateClientData.dob)}
                                    format="MM-DD-YYYY"
                                    onChange={handleChangeDate}
                                />
                            </div>
                        </div>
                        <div className="col-4">
                            <label htmlFor="gender" style={style.columnHeading}>Gender
                                <span style={{color:"red"}}> *</span></label>
                            <div className="select-input selects h40" style={{marginTop: "12px", width: "90%"}}>
                                <Select id="gender"
                                        value={corporateClientData && corporateClientData.gender}
                                        onChange={(e) => {
                                            this.setState({isBlocking: true});
                                            this.props.handleChangeCorporateClientEdit("gender", e);
                                        }}
                                >
                                    <Option value="MALE">Male</Option>
                                    <Option value="FEMALE">Female</Option>
                                    <Option value="OTHER">Other</Option>
                                </Select>
                            </div>
                        </div>

                        <div className="col-4">
                            <label htmlFor="maritalStatus" style={style.columnHeading}>Marital
                                Status <span style={{color:"red"}}> *</span></label>
                            <div className="select-input selects h40" style={{marginTop: "12px", width: "90%"}}>
                                <Select
                                        value={corporateClientData && corporateClientData.maritalStatus}
                                        id="maritalStatus"
                                        onChange={(e) => {
                                            this.setState({isBlocking: true});
                                            this.props.handleChangeCorporateClientEdit("maritalStatus", e);
                                        }}
                                >
                                    <Option value="SINGLE">Single</Option>
                                    <Option value="MARRIED">Married</Option>
                                    <Option value="DIVORCED">Divorced</Option>
                                </Select>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "2rem"}}>
                        <div className="col-4">
                            <label htmlFor="county" style={style.columnHeading}>County</label>
                            <input
                                id="county"
                                style={style.inputField}
                                value={corporateClientData && corporateClientData.county}
                                onChange={(e) => {
                                    e.preventDefault();
                                    this.setState({isBlocking: true});
                                    this.props.handleChangeCorporateClientEdit(e.target.id, e.target.value);
                                }}
                            />
                        </div>
                    </div>
                    <div className="row" style={{marginTop: '2rem'}}>
                        <div className="col-4" style={{position: 'inherit'}}>
                            <Checkbox
                                id="isEnableTransaction"
                                onChange={(e) => {
                                    e.preventDefault();
                                    this.setState({isBlocking: true});
                                    this.props.handleChangeCorporateClientEdit(e.target.id, e.target.checked);
                                }}
                                checked={corporateClientData && corporateClientData.isEnableTransaction ? true : false}
                                value={corporateClientData && corporateClientData.isEnableTransaction}
                                style={style.columnHeading}>
                                Enable Transaction
                            </Checkbox>
                        </div>
                    </div>

                    {!(this.state.contacts.length > 0) ?
                        <div style={{cursor: 'pointer', marginTop: '1.5rem',width:'15%'}}
                             onClick={e => {
                                 e.preventDefault();
                                 this.setState({
                                     isBlocking: false
                                 });
                                 showInputForField();
                             }}>
                            <img src="/assets/images/add-button-inside-circle.svg" alt="Add Button"
                                 style={{width: '22px', height: '22px', cursor: 'pointer'}}/>
                            <span style={{fontSize: '14px', paddingLeft: '4px'}}>Add Contact</span>
                        </div>
                        :
                        <div style={{marginTop: '2rem'}}>
                            {openFieldForContact()}
                            <div style={{ display: 'block', marginTop: '1rem'}}>
                            <span style={{cursor: 'pointer'}}
                                  onClick={e => {
                                      e.preventDefault();
                                      this.setState({isBlocking: false});
                                      showInputForField();

                                  }}>
                             <img src="/assets/images/add-button-inside-circle.svg" alt="Add Button"
                                  style={{width: '22px', height: '22px', cursor: 'pointer'}}/>
                                <span style={{fontSize: '14px', paddingLeft: '4px'}}>Add More</span>
                            </span>
                            </div>

                        </div>}

                    <div className='row'>
                        <div className="col-4"/>
                        <div className="col-4"/>
                        <div className="col-4">
                            <button
                                // disabled={!value}
                                className="btn btn-primary"
                                style={style.nextButton}
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.setState({isBlocking: false});
                                    editClientAPICall();
                                    // this.props.editClient(corporateClientData,this.state.corporateId,this.props)
                                }}
                            > Update
                            </button>
                        </div>
                    </div>
                </div>

                <Dialog
                    open={this.state.openDeleteContactDialogue}
                    onClose={handleCloseDeleteContactDialogue}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <div style={{background: "#ffffff", borderRadius: "18px"}}>
                        <DialogTitle
                            style={style.dialogHeaderForAddUser}
                            id="draggable-dialog-title"
                        />
                        <DialogContent
                            style={{
                                background: "white",
                                borderTopLeftRadius: "8px",
                                borderTopRightRadius: "8px",
                                paddingLeft: "1.5rem !important",
                                paddingRight: "1.5rem !important",
                                textAlign: "center",
                                width: '450px'
                            }}
                        >
                            <DialogContentText>
                                <h3 style={{color: "#8BC83F", padding: "0.8rem"}}>
                                    Confirmation
                                </h3>
                                Do you want to delete contact?
                                <div
                                    className="row"
                                    style={{
                                        paddingLeft: "10px",
                                        paddingRight: "10px",
                                        paddingBottom: "1rem",
                                        paddingTop: "1.6rem"
                                    }}
                                >
                                    <div className={"col-6"}>
                                        <Button
                                            autoFocus
                                            onClick={handleCloseDeleteContactDialogue}
                                            style={style.cancelButton}
                                        >
                                            cancel
                                        </Button>
                                    </div>
                                    <div className={"col-6"}>
                                        <Button
                                            onClick={e => {
                                                e.preventDefault();
                                                handleOkDeleteContactDialogue();
                                            }}
                                            style={style.addButton}
                                        >
                                            ok
                                        </Button>
                                    </div>
                                </div>
                            </DialogContentText>
                        </DialogContent>
                    </div>
                </Dialog>

                <Snackbar
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right"
                    }}
                    // open={this.props.state.corporateClientState.openCorporateClientFormSnackBar}
                    autoHideDuration={6000}
                    onClose={this.props.handleSnackBarClose}
                >
                    <MySnackbarContentWrapper
                        onClose={this.props.handleSnackBarClose}
                        variant="error"
                        message={this.props.state.corporateClientState.errorMsgForCorporateClient}
                    />
                </Snackbar>
            </React.Fragment>
        );
    }
}

const style = {
    container: {
        background: "#ffffff",
        margin: "78px 3% 3% 3%",
        boxShadow:
            "rgba(0, 0, 0, 0) 0px 0px 1px 0px, rgba(0, 0, 0, 0.19) 0px 1px 4px 0px",
        paddingLeft: '3rem',
        paddingTop: '2rem'
    },
    breadcrumb: {
        fontSize: "14px",
        borderBottom: "1px solid #dddddd",
        paddingTop: "12px",
        paddingBottom: "12px",
        paddingLeft: "2.5%",
        color: "#8BC83F",
        fontWeight: "bold",
        position: 'fixed',
        width: '100%',
        background: 'white',
        zIndex:1
    },
    link: {
        color: '#8BC83F'
    },
    columnHeading: {
        color: '#625F5F',
        marginBottom: '2px',
        fontSize: '16px',
        width: '100%'
    },
    inputField: {
        border: '0',
        backgroundColor: '#F4F5F9',
        color: 'rgb(130, 132, 129)',
        fontSize: '14x',
        height: '40px',
        width: '90%',
        paddingTop: '0px',
        marginTop: '16px',
        paddingLeft: '15px'
    },
    expandMoreIcon: {
        position: 'relative',
        right: '9%',
        top: '8px',
        color: '#C8C5C5',
        fontSize: '35px',
    },
    nextButton: {
        backgroundColor: '#8BC83F',
        float: 'right',
        width: '50%',
        height: '40px',
        border: '0',
        color: '#fff',
        fontSize: '17px',
        fontWeight: 'bold',
        marginTop: '31px',
        marginRight: '10%',
        marginBottom: '1.5rem'
    },
    selectPlaceholder: {
        fontSize: '13px !important'
    },
    dropdownInput: {
        paddingLeft: '8px',
        height: "40px",
        color: "#606060",
        backgroundColor: "#F4F5F9",
        border: "none",
        width: '100%',
        fontSize: '15px',
        marginBottom: '1.5rem',
    },
    select: {
        position: "relative",
        height: "40px",
        marginTop: '10px',
    },
    expandMoreIconContact: {
        position: 'absolute',
        right: '8px',
        top: '8px',
        color: '#C8C5C5',
        fontSize: '35px',
    },
    columnHeadingContact:{
        color: '#625F5F',
        fontSize: '16px',
        width: '100%',
        marginBottom:0
    },
    inputFieldContact: {
        border: '0',
        backgroundColor: '#F4F5F9',
        color: 'rgb(130, 132, 129)',
        fontSize: '14x',
        height: '40px',
        width: '90%',
        paddingTop: '0px',
        marginTop: '10px',
        marginBottom:'15px',
        paddingLeft: '13px'
    },
    addButton: {
        background: "#8BC83F",
        color: "white",
        width: "100%",
        padding: "0.5rem",
        border: "1px solid #8BC83F"
    },
    cancelButton: {
        border: "1px solid #8BC83F",
        color: "#8BC83F",
        width: '100%',
        padding: '0.5rem'
    },
};

export default CorporateClientEditFormScreen;
